import { createReducer } from "../utils";
import {
  GFY_FEED_SUCCESS,
  GFY_FEED_REQUEST,
  GFY_FEED_FAILURE,
  GET_GFY_SUCCESS
} from "../constants";

const initialState = {
  data: null,
  isFetching: false
};

export default createReducer(initialState, {
  [GFY_FEED_SUCCESS]: (state, payload) => {
    return Object.assign({}, state, {
      data: payload.items,
      total: payload.total,
      isFetching: false
    });
  },
  [GFY_FEED_REQUEST]: (state, payload) => {
    return Object.assign({}, state, {
      isFetching: true
    });
  },
  [GET_GFY_SUCCESS]: (state, payload) => {
    const existingData = state.data || [];
    return Object.assign({}, state, {
      data: [...existingData, ...payload.data.items],
      total: payload.data.total,
      isFetching: false
    });
  }
});
